exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/sortable-column/sortable-column.component.css
// module id = ../../../../../src/app/sortable-column/sortable-column.component.css
// module chunks = main